// ** Amplify
import { API } from "aws-amplify"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"

// ** constants
import { globalConst } from "@constants/global"

// **  utility
import { isEmpty, drop } from "lodash"

// ** fuzzy search support
import Fuse from "fuse.js"

/** initla state for auth store  */
const initialState = {
  data: [],
  sales: [],
  items: [],
  count: "",
  current: {},
  perPageValues: [25, 50, 100, 150, 200],
  itemPerPage: 25,
  itemPerPageItems: 25,
  currentPage: 1,
  currentPageItems: 1,
  filters: {
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  filtersItems: {
    parent: {
      value: "ALL",
      label: "label_all"
    },
    status: {
      value: "ALL",
      label: "label_all"
    }
  },
  message: "",
  keyword: null,
  keyWordItems: null,
  action: globalConst.action.NONE
}

export const exhibitions = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    setCurrentPage: (s, payload) => {
      return {
        ...s,
        currentPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrentPageItems: (s, payload) => {
      return {
        ...s,
        currentPageItems: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCount: (s, payload) => {
      return {
        ...s,
        count: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    updateItem: (s, payload) => {
      const index = s.items.findIndex((e) => e.pk === payload.pk)
      const item = s.items[index]
      item.images = item.images.filter((e) => e !== payload.image)
      const _data = s.items.filter((e) => e.pk !== payload.pk)
      _data[index] = item

      return {
        ...s,
        items: _data
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    updateSingleItem: (s, payload) => {
      const index = s.items.findIndex((e) => e.pk === payload.pk)
      const item = payload
      const _data = s.items.filter((e) => e.pk !== payload.pk)
      _data[index] = item

      return {
        ...s,
        items: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setItems: (s, payload) => {
      return {
        ...s,
        items: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setSales: (s, payload) => {
      return {
        ...s,
        sales: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    replaceRecord: (s, payload) => {
      const _data = s.data
      const index = s.data.findIndex((e) => e.pk === payload.pk)
      const item = s.data.find((e) => e.pk === payload.pk)
      item.status = payload.status
      _data[index] = item

      return {
        ...s,
        data: _data
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeywordItems: (s, payload) => {
      return {
        ...s,
        keyWordItems: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setSubItemsPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPageItems: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.exhibitions],
        (exhibitions, exhibitionsLoading) => {
          return exhibitionsLoading.error || ""
        }
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.exhibitions],
        (exhibitions, exhibitionsLoading) => exhibitionsLoading.success
      )
    },
    /**
     *
     * @returns
     */
    paginationData() {
      return createSelector([slice], (exhibitions) => {
        let _data = exhibitions.data
        if (!isEmpty(exhibitions.filters)) {
          const status = exhibitions.filters.status
          _data = !!status
            ? status.value !== "ALL"
              ? _data.filter((e) => e.status.value === status)
              : _data
            : _data
        }
        if (!!exhibitions.keyword) {
          const options = {
            keys: ["phone", "title", "titleAr", "whatsapp"]
          }
          const fuse = new Fuse(exhibitions.data, options)
          _data = fuse.search(exhibitions.keyword)
          _data = _data.map((e) => e.item)
        }
        const offset = (exhibitions.currentPage - 1) * exhibitions.itemPerPage
        _data = drop(_data, offset).slice(0, exhibitions.itemPerPage)
        return _data
      })
    },
    /**
     *
     * @returns
     */
    paginationItemsData() {
      return createSelector([slice], (exhibitions) => {
        let _data = exhibitions.items
        if (!isEmpty(exhibitions.filtersItems)) {
          const status = exhibitions.filtersItems.status
          _data = !!status
            ? status.value !== "ALL"
              ? _data.filter((e) => e.status.value === status)
              : _data
            : _data
        }
        if (!!exhibitions.keyWordItems) {
          const options = {
            keys: ["title", "titleAr", "phone", "whatsapp"]
          }
          const fuse = new Fuse(exhibitions.items, options)
          _data = fuse.search(exhibitions.keyWordItems)
          _data = _data.map((e) => e.item)
        }

        const offset =
          (exhibitions.currentPageItems - 1) * exhibitions.itemPerPageItems
        _data = drop(_data, offset).slice(0, exhibitions.itemPerPageItems)
        return _data
      })
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchAgences() {
      appLogger.info("fetchAgences", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.FETCH_AGENCES)
      try {
        const { items, count } = await API.get(
          "exhibitionsApiGateway",
          "/parents"
        )

        this.setData(items)
        // this.setCount(count)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     */
    async fetchItems() {
      appLogger.info("fetchItems", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.FETCH_AGENCES_ITEMS)
      try {
        const { items, count } = await API.get(
          "exhibitionsApiGateway",
          "/exibitions"
        )

        this.setItems(items)
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     */
    async saveItem(payload) {
      appLogger.info("saveItem", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.SAVE_AGENCES_ITEM)
      try {
        const result = await API.post("exhibitionsApiGateway", "/exibitions", {
          body: payload
        })

        this.setMessage("msg_item_saved_successfully")
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     */
    async clearCache() {
      appLogger.info("clearCache", `[REDUX][${STORES.EXHIBITIONS}]`)

      try {
        const result = await API.post("exhibitionsApiGateway", "/cache", {
          body: {}
        })
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} payload
     */
    async updateAgenceItem(payload) {
      appLogger.info("updateAgenceItem", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.UPDATE_AGENCES_ITEM)
      try {
        const result = await API.put(
          "exhibitionsApiGateway",
          `/exibitions/${payload.pk}`,
          {
            body: payload
          }
        )

        this.setMessage("msg_item_saved_successfully")
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     * @param {*} payload
     */
    async getAgenceItem(pk) {
      appLogger.info("getAgenceItem", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.GET_AGENCES_ITEM)
      try {
        const result = await API.get(
          "exhibitionsApiGateway",
          `/exibitions/${pk}`
        )
        this.setCurrent(result)
        // this.setMessage("msg_item_saved_successfully")
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     */
    async saveAgence(payload) {
      appLogger.info("saveAgence", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.SAVE_AGENCES)
      try {
        await API.post("exhibitionsApiGateway", "/parents", {
          body: payload
        })
        this.setMessage("msg_agency_added_sucess")
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} payload
     */
    async updateAgence(payload) {
      appLogger.info("updateAgence", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.UPDATE_AGENCES)
      try {
        await API.put("exhibitionsApiGateway", `/parents/${payload.pk}`, {
          body: payload
        })
        this.setMessage("msg_agency_updated_sucess")
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} pk
     */
    async getAgence(pk) {
      appLogger.info("getAgence", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.GET_SINGLE_AGENCY)
      try {
        const { item } = await API.get(
          "exhibitionsApiGateway",
          `/parents/${pk}`
        )
        this.setCurrent(item)
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     * @param {*} pk
     */
    async deleteAgence({ pk, rate }) {
      appLogger.info(`deleteAgence ${pk}`, `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.DELETE_AGENCES)
      try {
        await API.post("exhibitionsApiGateway", `/parents/${pk}/rm`, {
          body: { rate }
        })
        this.setMessage("msg_agency_deleted_sucess")
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} pk
     */
    async deleteAgenceItem({ pk, createdAt }) {
      appLogger.info(`deleteAgenceItem ${pk}`, `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.DELETE_AGENCES_ITEM)
      try {
        await API.post("exhibitionsApiGateway", `/exibitions/${pk}/rm`, {
          body: { createdAt }
        })
        this.setMessage("msg_agency_deleted_sucess")
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     * @param {*} param0
     */
    async deleteImage({ pk, image, createdAt, images }) {
      appLogger.info("updateCover", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.DELETE_PHOTO_AGENCES_ITEM)

      try {
        await API.post(
          "exhibitionsApiGateway",
          `/exibitions/${pk}/images/delete`,
          {
            body: { createdAt, images }
          }
        )
        this.updateItem({ pk, image })
      } catch (error) {
        throw new Error(error)
      }
    },

    async addImage({ pk, createdAt, image, images }) {
      appLogger.info("addImage", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.ADD_PHOTO_AGENCES_ITEM)

      const _images = images
      _images.push(image)
      try {
        await API.post("exhibitionsApiGateway", `/exibitions/${pk}/images`, {
          body: { images: _images, createdAt }
        })
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} pk
     */
    async refreshAgencyItem(pk) {
      appLogger.info("refreshAgencyItem", `[REDUX][${STORES.EXHIBITIONS}]`)
      this.setAction(globalConst.action.GET_AGENCES_ITEM)

      try {
        const result = await API.get(
          "exhibitionsApiGateway",
          `/exibitions/${pk}`
        )

        this.updateSingleItem(result)
      } catch (error) {
        throw new Error(error)
      }
    },

    /**
     *
     */
    onAcionReset() {
      this.setAction(globalConst.action.NONE)
    },
    /**
     *
     * @param {*} param0
     */
    resetCurrentRecord(payload = {}) {
      this.setCurrent(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemPerPageChange(payload) {
      this.setitemPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onSubItemPerPageChange(payload) {
      this.setSubItemsPerPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onFiltersChange(payload) {
      this.setFilters(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onCurrentPageChange(payload) {
      this.setCurrentPage(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemsCurrentPageChange(payload) {
      this.setCurrentPageItems(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onKeywordChange(payload) {
      this.setKeyword(payload)
    },
    /**
     *
     * @param {*} payload
     */
    onItemKeywordChanges(payload) {
      this.setKeywordItems(payload)
    }
  })
}
